import { render, staticRenderFns } from "./simplifyOwnerCar.vue?vue&type=template&id=1cb24a18&scoped=true"
import script from "./simplifyOwnerCar.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerCar.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerCar.vue?vue&type=style&index=0&id=1cb24a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb24a18",
  null
  
)

export default component.exports